exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-footer[data-v-95ce401c]{margin:0;white-space:nowrap}.browse-mode-item[data-v-95ce401c]{background:#0277bd!important;border-radius:6px}", ""]);

// exports
